import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridVue } from "ag-grid-vue";
import { noRowsTemplate } from "@/components/TransactionsPage/noRowsTemplate";
import statusInTable from "@/components/TransactionsPage/StatusInTable/index.vue";
import detailsInTable from "@/components/TransactionsPage/DetailsInTable/index.vue";
import dayjs from "dayjs";
import { OfflinePaymentService } from "@/services";
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";
import { mapActions } from "vuex";
import * as types from "@/store/types";
export default {
  name: "offline-payment-table",
  components: { AgGridVue, statusInTable, detailsInTable },
  props: [],
  mixins: [$exponent, $thousandMask],
  data() {
    return {
      page: 1,
      loading: false,
      dataTableItem: "",
      gridOptions: null,
      gridApi: null,
      localeText: null,
      columnApi: null,
      paginationPageSize: null,
      paginationNumberFormatter: null,
      item: "10",
      offlinePaymentHeader: null,
      defaultOfflinePaymentHeader: null,
      showOfflinePaymentData: [],
      showPaginationCount: {}
    };
  },
  computed: {},
  beforeMount() {
    this.gridOptions = {
      overlayNoRowsTemplate: noRowsTemplate.template
    };
    this.offlinePaymentHeader = [
      {
        colId: 0,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.paymentDate"
        ),
        field: "date",
        unSortIcon: true,
        flex: 1,
        width: 120,
        minWidth: 120
      },
      {
        colId: 1,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.amount"
        ),
        field: "amount",
        unSortIcon: true,
        flex: 1,
        width: 180,
        minWidth: 180
      },
      {
        colId: 2,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.status"
        ),
        field: "status",
        unSortIcon: true,
        cellRendererFramework: "statusInTable",
        flex: 1,
        width: 120,
        minWidth: 120
      },
      {
        colId: 3,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.action"
        ),
        unSortIcon: true,
        field: "operation",
        cellRendererFramework: "detailsInTable",
        headerClass: "operation-cell header-table-ag-grid-cell",
        flex: 1,
        width: 100,
        minWidth: 100
      }
    ];
    this.defaultOfflinePaymentHeader = {
      headerClass: "header-table-ag-grid-cell",
      lockPosition: true,
      icons: {
        sortUnSort:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>',
        sortAscending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#500fe9"></path></svg>',
        sortDescending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#500fe9"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>'
      }
    };
    this.paginationPageSize = 10;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.offlinePaymentData(1);
  },
  methods: {
    ...mapActions({
      offlinePaymentAction:
        types.transactions.actions.ACTION_TRANSACTIONS_OFFLINE
    }),
    offlinePaymentData(page) {
      this.showPaginationCount = {};
      this.showOfflinePaymentData = [];
      OfflinePaymentService.getOfflinePaymentData(page).then(response => {
        this.offlinePaymentAction(response.data);
        this.showPaginationCount = response.data.pagination;
        response.data.data.forEach(elem => {
          this.showOfflinePaymentData.push({
            amount: this.$thousandMask(elem.amount),
            date: this.formatDate(parseInt(elem.pay_date)),
            status: { locale: elem.status_locale, style: elem.status_color },
            operation: {
              transaction_type: "offlinePayment",
              drawer: true,
              reference_number: elem.id
            }
          });
        });
      });
    },
    formatDate(date) {
      return dayjs(date).format("YYYY/MM/DD");
    },
    formatTimes(time) {
      return dayjs(time).format("mm : HH");
    }
  }
};
